// src/pages/AdminPage.js

import { Header } from '../components/Header.js';
import { Footer } from '../components/Footer.js';
import { Notification } from '../components/Notification.js';
import { api } from '../services/api.js';
import { authService } from '../services/authService.js'; //
import moment from 'moment-timezone';
import { renderUsersManagement } from '../components/admin/modules/NetworkManager.js';
import { renderTracksManagement, renderRacesManagement, renderHorsesJockeysManagement } from '../components/admin/modules/RaceManager.js';
import { renderWithdrawalsManagement, renderTaquillaReports, renderReportsAnalytics, renderCommissionsManagement, renderExecutiveDashboard } from '../components/admin/modules/Treasury.js';
import { renderRaceResultsManagement } from '../components/admin/modules/ResultsManager.js';
import { renderRemateManagement } from '../components/admin/modules/RemateManager.js';
import { renderGlobalConfig, renderSignalsManagement, renderAppInstaller, renderProfitReport } from '../components/admin/modules/SystemConfig.js';

const VENEZUELA_TIMEZONE = 'America/Caracas';

const checkAuthError = (e) => {
    const msg = String(e?.message || e?.error || e);
    if (e?.status === 401 || e?.response?.status === 401 || msg.includes('401') || /token|expirad|autorizad|unauthorized/i.test(msg)) {
        authService.logout(); window.location.href = '/login'; return true;
    }
    return false;
};

export function AdminPage() {
    // Verificación inicial de sesión activa
    api.get('/configs/global').catch(e => checkAuthError(e));

    const page = document.createElement('div');
    page.className = 'admin-page'; // Se quita 'page' para un control total del layout

    page.appendChild(Header());

    const mainContent = document.createElement('main');
    mainContent.className = 'admin-layout-container';
    page.appendChild(mainContent);

    const notificationContainer = document.createElement('div');
    notificationContainer.className = 'notification-container-admin';
    mainContent.appendChild(notificationContainer);

    const styleElement = document.createElement('style');
    styleElement.textContent = `
        /* --- NUEVO LAYOUT: SIDEBAR + CONTENT --- */
        .admin-page {
            background-color: #0f172a;
            color: #f8fafc;
            font-family: 'Roboto', sans-serif;
            min-height: 100vh;
        }
        .admin-layout-container {
            display: flex;
            max-width: 100%;
            padding: 0;
            margin: 0;
        }
        .admin-sidebar {
            width: 260px;
            background: #1e293b;
            border-right: 1px solid #334155;
            padding: 20px 10px;
            height: calc(100vh - 70px); /* Resta la altura del header */
            overflow-y: auto;
            flex-shrink: 0;
        }
        .admin-sidebar-group h4 {
            color: #94a3b8;
            font-size: 0.75rem;
            font-weight: bold;
            text-transform: uppercase;
            padding: 15px 10px 5px 10px;
            letter-spacing: 1px;
        }
        .admin-sidebar-link {
            display: flex;
            align-items: center;
            gap: 12px;
            padding: 10px 15px;
            color: #cbd5e1;
            text-decoration: none;
            border-radius: 6px;
            font-weight: 500;
            font-size: 0.9rem;
            transition: all 0.2s ease;
            cursor: pointer;
        }
        .admin-sidebar-link:hover {
            background-color: #334155;
            color: white;
        }
        .admin-sidebar-link.active {
            background-color: #D4AF37;
            color: #1e293b;
            font-weight: bold;
            box-shadow: 0 4px 10px rgba(212, 175, 55, 0.2);
        }
        .admin-sidebar-link i {
            width: 20px;
            text-align: center;
        }
        .admin-main-content {
            flex-grow: 1;
            padding: 25px;
            height: calc(100vh - 70px);
            overflow-y: auto;
        }

        /* --- ESTILOS BASE Y GLOBALES (SOBRIO E INMERSIVO) --- */
        h3, h4, h5 {
            color: #D4AF37; /* Dorado institucional */
            font-weight: 900;
            letter-spacing: 0.5px;
            margin-bottom: 1rem;
        }
        .admin-main-content h3 { font-size: 1.8rem; border-bottom: 2px solid #334155; padding-bottom: 10px; }
        
        /* --- BOTONES PREMIUM --- */
        .btn-action, .btn-primary, .btn-success, .btn-warning, .btn-danger, .btn-secondary, .btn-header-lg {
            border: none;
            padding: 8px 16px;
            border-radius: 6px;
            font-weight: bold;
            cursor: pointer;
            transition: all 0.2s ease;
            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
            display: inline-flex;
            align-items: center;
            justify-content: center;
            gap: 5px;
        }
        .btn-action:active, .btn-primary:active, .btn-success:active, .btn-danger:active { transform: scale(0.95); }
        
        .btn-primary { background: linear-gradient(135deg, #D4AF37 0%, #b48505 100%); color: black; }
        .btn-primary:hover { background: linear-gradient(135deg, #FCD34D 0%, #D4AF37 100%); }
        
        .btn-success { background: linear-gradient(135deg, #10b981 0%, #059669 100%); color: white; }
        .btn-success:hover { background: linear-gradient(135deg, #34d399 0%, #10b981 100%); }
        
        .btn-danger, .btn-danger-action { background: linear-gradient(135deg, #ef4444 0%, #b91c1c 100%); color: white; border:none; padding:8px 16px; border-radius:6px; cursor:pointer; font-weight:bold; }
        .btn-danger:hover, .btn-danger-action:hover { background: linear-gradient(135deg, #f87171 0%, #ef4444 100%); }
        
        .btn-warning { background: linear-gradient(135deg, #f59e0b 0%, #d97706 100%); color: white; }
        .btn-secondary { background: #334155; color: #cbd5e1; border: 1px solid #475569; }
        .btn-secondary:hover { background: #475569; color: white; }

        /* --- TABLAS MODERNAS --- */
        .table, .remate-table {
            width: 100%;
            border-collapse: separate;
            border-spacing: 0;
            background: #1e293b;
            border-radius: 8px;
            overflow: hidden;
            border: 1px solid #334155;
        }
        .table th, .remate-table th {
            background: #0f172a; /* Unificar con el fondo principal para mayor consistencia */
            color: #D4AF37;
            padding: 12px 15px;
            text-align: left;
            font-size: 0.85rem;
            text-transform: uppercase;
            letter-spacing: 0.5px;
            border-bottom: 2px solid #D4AF37;
        }
        /* FIX: Override para que las filas de la tabla no hereden fondos claros de estilos globales */
        .admin-main-content .table tbody tr,
        .admin-main-content .remate-table tbody tr {
            background-color: transparent;
        }
        .table td, .remate-table td {
            padding: 12px 15px;
            color: #f8fafc;
            border-bottom: 1px solid #334155;
            vertical-align: middle;
            transition: background-color 0.2s ease; /* Transición suave para el hover */
        }
        .table tbody tr:hover td, .remate-table tbody tr:hover td {
            background-color: #334155; /* Color de hover sólido y uniforme */
        }
        .table tr:last-child td, .remate-table tr:last-child td { border-bottom: none; }

        /* --- FORMULARIOS E INPUTS --- */
        .form-grid {
            display: grid;
            grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
            gap: 15px;
            margin-bottom: 15px;
        }
        .form-group label {
            display: block;
            margin-bottom: 5px;
            color: #94a3b8;
            font-size: 0.85rem;
            font-weight: bold;
        }
        .remate-input, .remate-select, input[type="text"], input[type="number"], input[type="date"], input[type="datetime-local"], input[type="email"], input[type="tel"], input[type="password"], input[type="file"], select, textarea {
            width: 100%;
            padding: 10px;
            background-color: #0f172a; /* Fondo Oscuro */
            border: 1px solid #475569; /* Borde gris medio */
            color: #f8fafc; /* TEXTO BLANCO */
            border-radius: 6px;
            font-family: inherit;
            transition: border-color 0.2s ease, box-shadow 0.2s ease;
            box-sizing: border-box; /* Previene desbordamiento */
        }
        /* Corrección especial para el placeholder en fondos oscuros */
        ::placeholder {
            color: #64748b !important;
            opacity: 1; /* Firefox */
        }
        .remate-input:focus, .remate-select:focus, input:focus, select:focus, textarea:focus {
            outline: none;
            border-color: #D4AF37;
            box-shadow: 0 0 0 2px rgba(212, 175, 55, 0.2);
            background-color: #1e293b; /* Aclara un poco al enfocar */
        }
        /* Color del texto de las opciones en los selects (para Safari/Chrome) */
        select option {
            background-color: #0f172a;
            color: #f8fafc;
        }
        
        /* Contenedores de Paneles (Panels) */
        .remate-dashboard {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 20px;
        }
        @media (max-width: 768px) {
            .remate-dashboard { grid-template-columns: 1fr; }
        }
        .remate-panel {
            background: linear-gradient(145deg, #1e293b 0%, #151e2e 100%);
            border: 1px solid #334155;
            border-radius: 10px;
            padding: 20px;
            box-shadow: 0 10px 15px -3px rgba(0,0,0,0.5);
        }
        .remate-header {
            color: #D4AF37;
            border-bottom: 1px solid #334155;
            padding-bottom: 12px;
            margin-bottom: 15px;
            font-size: 1.2rem;
            font-weight: 900;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }

        /* --- MODALES --- */
        .user-modal-overlay, .signal-modal-overlay, .modal-overlay {
            position: fixed;
            top: 0; left: 0; width: 100%; height: 100%;
            background-color: rgba(0, 0, 0, 0.85);
            backdrop-filter: blur(4px);
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 10000;
        }
        .user-modal-content, .signal-modal-content, .modal-content {
            background: #1e293b; /* Fondo oscuro para el modal */
            border: 1px solid #D4AF37;
            padding: 25px;
            border-radius: 12px;
            box-shadow: 0 15px 25px rgba(0,0,0,0.6), 0 0 15px rgba(212, 175, 55, 0.1);
            width: 90%;
            max-width: 500px;
            color: #f8fafc; /* Texto blanco en el modal */
            max-height: 90vh;
            overflow-y: auto;
        }
        .user-modal-content h3 { color: #D4AF37; text-align:center; border-bottom:1px solid #334155; padding-bottom:10px; }
        .user-modal-buttons, .signal-modal-buttons {
            display: flex;
            justify-content: flex-end;
            gap: 10px;
            margin-top: 20px;
            padding-top: 15px;
            border-top: 1px solid #334155;
        }

        /* Pestañas (Tabs) */
        .profile-tabs {
            display: flex;
            gap: 5px;
            background: #0f172a;
            padding: 5px;
            border-radius: 8px;
            border: 1px solid #334155;
            margin-bottom: 15px;
        }
        .profile-tab {
            flex: 1;
            padding: 8px 15px;
            background: transparent;
            color: #94a3b8;
            border: 1px solid transparent;
            border-radius: 5px;
            cursor: pointer;
            font-weight: bold;
            transition: all 0.2s;
        }
        .profile-tab.active {
            background: #1e293b;
            color: white;
            border-color: #475569;
            box-shadow: 0 2px 4px rgba(0,0,0,0.2);
        }
        
        .hidden { display: none !important; }
        hr { border-color: #334155; margin: 20px 0; }
        
    `;
    page.appendChild(styleElement);

    const sidebar = document.createElement('aside');
    sidebar.className = 'admin-sidebar';

    const detailSection = document.createElement('section');
    detailSection.id = 'adminDetailSection';
    detailSection.className = 'admin-main-content';

    mainContent.appendChild(sidebar);
    mainContent.appendChild(detailSection);

    const menuItems = [
        {
            category: 'Dashboard',
            items: [
                { name: 'Gestión de Remates VIP', id: 'remates-management', icon: 'fas fa-gavel' },
                { name: 'Resultados de Carreras', id: 'race-results', icon: 'fas fa-trophy' },
            ]
        },
        {
            category: 'Red Comercial',
            items: [
                { name: 'Gestión de Usuarios', id: 'users-management', icon: 'fas fa-users-cog' },
                { name: 'Usuarios Remate VIP', id: 'remate-users-management', icon: 'fas fa-crown' },
                { name: 'Registro Web (Taquillas)', id: 'cashier-register', icon: 'fas fa-mobile-alt' },
                { name: 'Supervisores Web', id: 'dashboard-admins', icon: 'fas fa-user-tie' },
                { name: 'App Móvil (QR)', id: 'app-installer', icon: 'fas fa-qrcode' },
            ]
        },
        {
            category: 'Core Hípico',
            items: [
                { name: 'Gestión de Hipódromos', id: 'tracks-management', icon: 'fas fa-map-marked-alt' },
                { name: 'Gestión de Carreras', id: 'races-management', icon: 'fas fa-horse-head' },
                { name: 'Gestión de Participantes', id: 'horses-jockeys-management', icon: 'fas fa-users' },
            ]
        },
        {
            category: 'Tesorería',
            items: [
                { name: 'Dashboard de Auditoría', id: 'executive-dashboard', icon: 'fas fa-chart-bar' }, // <-- NUEVA LÍNEA
                { name: 'Gestión de Caja (App)', id: 'withdrawals-management', icon: 'fas fa-cash-register' },
                { name: 'Reporte de Taquillas', id: 'taquilla-reports', icon: 'fas fa-receipt' },
                { name: 'Reporte App (Win/Place)', id: 'reports-analytics', icon: 'fas fa-chart-line' },
                { name: 'Liquidación Remates', id: 'profit-report', icon: 'fas fa-chart-pie' },
                { name: 'Estructura de Comisiones', id: 'commissions-management', icon: 'fas fa-percent' } 
            ]
        },
        {
            category: 'Configuración',
            items: [
                { name: 'Configuración Global', id: 'global-config', icon: 'fas fa-cogs' },
                { name: 'Gestión de Señales TV', id: 'signals-management', icon: 'fas fa-satellite-dish' },
            ]
        }
    ];

    const renderMenu = () => {
        sidebar.innerHTML = '';
        menuItems.forEach(group => {
            const groupDiv = document.createElement('div');
            groupDiv.className = 'admin-sidebar-group';
            groupDiv.innerHTML = `<h4>${group.category}</h4>`;
            const list = document.createElement('ul');
            list.style.listStyle = 'none';
            list.style.padding = '0';
            group.items.forEach(item => {
                const li = document.createElement('li');
                li.innerHTML = `<a class="admin-sidebar-link" data-section-id="${item.id}"><i class="${item.icon}"></i> ${item.name}</a>`;
                list.appendChild(li);
            });
            groupDiv.appendChild(list);
            sidebar.appendChild(groupDiv);
        });

        sidebar.querySelectorAll('.admin-sidebar-link').forEach(link => {
            link.addEventListener('click', (e) => {
                const sectionId = e.currentTarget.dataset.sectionId;
                renderSection(sectionId);

                sidebar.querySelectorAll('.admin-sidebar-link').forEach(l => l.classList.remove('active'));
                e.currentTarget.classList.add('active');
            });
        });
    };

    async function renderSection(sectionId) {
        const sectionName = menuItems.flatMap(g => g.items).find(i => i.id === sectionId)?.name || 'Dashboard';
        detailSection.innerHTML = `<h3>${sectionName}</h3>`;
        notificationContainer.innerHTML = '';

        const contentContainer = document.createElement('div');
        detailSection.appendChild(contentContainer);

        switch (sectionId) {
            case 'remates-management':
                await renderRemateManagement(contentContainer, notificationContainer);
                break;
            case 'users-management':
                await renderUsersManagement(contentContainer, notificationContainer);
                break;
            case 'remate-users-management':
                await renderRemateUsersManagement(contentContainer, notificationContainer);
                break;
            case 'cashier-register':
                await renderCashierRegister(contentContainer, notificationContainer);
                break;
            case 'dashboard-admins':
                await renderDashboardAdmins(contentContainer, notificationContainer);
                break;
            case 'tracks-management':
                await renderTracksManagement(contentContainer, notificationContainer);
                break;
            case 'signals-management':
                await renderSignalsManagement(contentContainer, notificationContainer);
                break;
            case 'races-management':
                await renderRacesManagement(contentContainer, notificationContainer);
                break;
            case 'horses-jockeys-management':
                await renderHorsesJockeysManagement(contentContainer, notificationContainer);
                break;
            case 'taquilla-reports':
                await renderTaquillaReports(contentContainer, notificationContainer);
                break;
            case 'race-results':
                await renderRaceResultsManagement(contentContainer, notificationContainer);
                break;
            case 'reports-analytics':
                await renderReportsAnalytics(contentContainer, notificationContainer);
                break;
            case 'app-installer': 
                renderAppInstaller(contentContainer, notificationContainer); 
                break;
            case 'withdrawals-management':
                await renderWithdrawalsManagement(contentContainer, notificationContainer);
                break;
            // Agrega el caso debajo de withdrawals-management
            case 'commissions-management':
                await renderCommissionsManagement(contentContainer, notificationContainer);
                break;
            case 'executive-dashboard':
                await renderExecutiveDashboard(contentContainer, notificationContainer);
                break;
            case 'global-config':
                await renderGlobalConfig(contentContainer, notificationContainer);
                break;
            case 'profit-report':
                await renderProfitReport(contentContainer, notificationContainer);
                break;
            default:
                contentContainer.innerHTML = '<p>Selecciona una opción del menú lateral para comenzar.</p>';
        }
    }

    async function renderCashierRegister(container, notifContainer) {
        container.innerHTML = `
            <div class="content-card" style="background: #1e293b; padding: 25px; border-radius: 12px; border: 1px solid #334155; color: white;">
                <h4 style="color: #D4AF37; margin-top: 0;"><i class="fas fa-mobile-alt"></i> Nueva Taquilla PWA / Web</h4>
                <p style="color: #94a3b8; font-size: 0.9rem; margin-bottom: 20px;">Registra un nuevo operador de taquilla. El número de teléfono servirá como clave de vinculación para el entorno Web/Android, sin depender de Telegram.</p>
                <form id="register-cashier-form" style="display: grid; grid-template-columns: repeat(auto-fit, minmax(250px, 1fr)); gap: 15px;">
                    <div class="form-group"><label style="color: #cbd5e1; font-weight: bold; font-size: 0.85rem;">Usuario de Login</label><input type="text" id="reg-username" required class="remate-input" placeholder="Ej: taquilla_centro"></div>
                    <div class="form-group"><label style="color: #cbd5e1; font-weight: bold; font-size: 0.85rem;">Contraseña</label><input type="password" id="reg-password" required class="remate-input"></div>
                    <div class="form-group"><label style="color: #cbd5e1; font-weight: bold; font-size: 0.85rem;">Nombre del Responsable</label><input type="text" id="reg-fullname" required class="remate-input" placeholder="Ej: Juan Pérez"></div>
                    <div class="form-group"><label style="color: #cbd5e1; font-weight: bold; font-size: 0.85rem;">Email (Obligatorio)</label><input type="email" id="reg-email" required class="remate-input" placeholder="correo@ejemplo.com"></div>
                    <div class="form-group"><label style="color: #cbd5e1; font-weight: bold; font-size: 0.85rem;">Teléfono (Vinculación)</label><input type="tel" id="reg-phone" required class="remate-input" placeholder="Ej: 04141234567"></div>
                    <div class="form-group">
                        <label style="color: #cbd5e1; font-weight: bold; font-size: 0.85rem;">Moneda Base</label>
                        <select id="reg-currency" class="remate-select">
                            <option value="USD">Dólares (USD)</option>
                            <option value="VES">Bolívares (VES)</option>
                            <option value="COP">Pesos Colombianos (COP)</option>
                            <option value="BOTH">USD y VES (Ambos)</option>
                        </select>
                    </div>
                    <div class="form-group"><label style="color: #cbd5e1; font-weight: bold; font-size: 0.85rem;">Tasa Manual (0 = Auto)</label><input type="number" id="reg-rate" class="remate-input" value="0" step="0.01"></div>
                    <div class="form-group" style="grid-column: 1 / -1; margin-top: 10px;">
                        <button type="submit" class="btn-success" style="width: 100%; padding: 12px; font-size: 1.1rem;"><i class="fas fa-save"></i> Registrar Taquilla Independiente</button>
                    </div>
                </form>
            </div>
        `;

        container.querySelector('#register-cashier-form').addEventListener('submit', async (e) => {
            e.preventDefault();
            const btn = e.target.querySelector('button[type="submit"]');
            btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Registrando...';
            
            try {
                await api.post('/users', {
                    username: container.querySelector('#reg-username').value.trim(),
                    password: container.querySelector('#reg-password').value,
                    role: 'cashier',
                    full_name: container.querySelector('#reg-fullname').value.trim(),
                    email: container.querySelector('#reg-email').value.trim(),
                    phone_number: container.querySelector('#reg-phone').value.trim(),
                    currency_code: container.querySelector('#reg-currency').value,
                    auto_update_rate: parseFloat(container.querySelector('#reg-rate').value) === 0,
                    exchange_rate: parseFloat(container.querySelector('#reg-rate').value) || 0
                });
                Notification(notifContainer, 'Taquilla registrada correctamente. Lista para vinculación web/app.', 'success');
                e.target.reset();
            } catch (err) { if (checkAuthError(err)) return; Notification(notifContainer, err.message || 'Error en el registro', 'error'); } 
            finally { btn.disabled = false; btn.innerHTML = '<i class="fas fa-save"></i> Registrar Taquilla Independiente'; }
        });
    }

    async function renderDashboardAdmins(container, notifContainer) {
        container.innerHTML = `
            <div class="content-card" style="background: #1e293b; padding: 25px; border-radius: 12px; border: 1px solid #334155; color: white; margin-bottom: 20px;">
                <h4 style="color: #D4AF37; margin-top: 0;"><i class="fab fa-android"></i> Compartir App de Supervisión (APK)</h4>
                <p style="color: #94a3b8; font-size: 0.9rem; margin-bottom: 15px;">Ingresa el enlace de Google Drive de tu App Android para generar un mensaje de instalación y enviarlo a tus supervisores.</p>
                <div style="display: flex; gap: 10px; align-items: center; flex-wrap: wrap;">
                    <input type="url" id="apk-drive-link" class="remate-input" placeholder="Ej: https://drive.google.com/file/d/..." style="flex: 1; min-width: 250px;" value="${localStorage.getItem('admin_apk_drive_link') || ''}">
                    <button id="btn-copy-apk-msg" class="btn-primary" style="white-space: nowrap; padding: 10px 20px;"><i class="fas fa-copy"></i> Copiar Instrucciones</button>
                </div>
            </div>

            <div style="display: flex; gap: 20px; align-items: flex-start; flex-wrap: wrap;">
                <div class="content-card" style="flex: 1; min-width: 300px; background: #1e293b; padding: 25px; border-radius: 12px; border: 1px solid #334155; color: white;">
                    <h4 style="color: #D4AF37; margin-top: 0;"><i class="fas fa-user-plus"></i> Nuevo Supervisor</h4>
                    <p style="color: #94a3b8; font-size: 0.9rem; margin-bottom: 20px;">Crea un administrador para el telegram-dashboard. Asígnale taquillas específicas para monitorear.</p>
                    <form id="register-dashadmin-form" style="display: grid; grid-template-columns: 1fr; gap: 15px;">
                        <div class="form-group"><label style="color:#cbd5e1; font-weight:bold; font-size:0.85rem;">Usuario Login</label><input type="text" id="da-username" required class="remate-input"></div>
                        <div class="form-group"><label style="color:#cbd5e1; font-weight:bold; font-size:0.85rem;">Contraseña</label><input type="password" id="da-password" required class="remate-input"></div>
                        <div class="form-group"><label style="color:#cbd5e1; font-weight:bold; font-size:0.85rem;">Nombre Completo</label><input type="text" id="da-fullname" required class="remate-input"></div>
                        <div class="form-group"><label style="color:#cbd5e1; font-weight:bold; font-size:0.85rem;">Email</label><input type="email" id="da-email" required class="remate-input"></div>
                        <div class="form-group"><label style="color:#cbd5e1; font-weight:bold; font-size:0.85rem;">Teléfono (Opcional)</label><input type="tel" id="da-phone" class="remate-input"></div>
                        
                        <div class="form-group">
                            <label style="color:#cbd5e1; font-weight:bold; font-size:0.85rem;">Taquillas Asignadas</label>
                            <div id="da-cashiers-list" style="background: #0f172a; border: 1px solid #475569; border-radius: 6px; padding: 10px; max-height: 150px; overflow-y: auto;">
                                <i>Cargando taquillas...</i>
                            </div>
                        </div>

                        <button type="submit" class="btn-success" style="padding: 12px; font-size: 1.1rem; width: 100%;"><i class="fas fa-save"></i> Registrar Supervisor</button>
                    </form>
                </div>
                
                <div class="content-card" style="flex: 2; min-width: 400px; background: #1e293b; padding: 25px; border-radius: 12px; border: 1px solid #334155; color: white;">
                    <h4 style="color: #D4AF37; margin-top: 0;"><i class="fas fa-list"></i> Supervisores Registrados</h4>
                    <div id="da-list-container"><i>Cargando supervisores...</i></div>
                </div>
            </div>
        `;

        let cashiersList = [];
        let adminsList = [];

        try {
            const usersRes = await api.get('/users');
            cashiersList = usersRes.filter(u => u.role === 'cashier');
            const listDiv = container.querySelector('#da-cashiers-list');
            if (cashiersList.length === 0) {
                listDiv.innerHTML = '<span style="color:#ef4444">No hay taquillas creadas.</span>';
            } else {
                listDiv.innerHTML = cashiersList.map(c => `
                    <label style="display:flex; align-items:center; gap:8px; margin-bottom:8px; cursor:pointer; color:#f8fafc; font-size:0.9rem;">
                        <input type="checkbox" class="da-cashier-cb" value="${c.id}" style="width:auto;">
                        ${c.username} - ${c.full_name}
                    </label>
                `).join('');
            }
        } catch (e) { checkAuthError(e); console.error("Error fetching cashiers", e); }

        const loadAdmins = async () => {
            const listContainer = container.querySelector('#da-list-container');
            try {
                adminsList = await api.get('/users/dashboard-admins');
                if (adminsList.length === 0) {
                    listContainer.innerHTML = '<span style="color:#94a3b8">No hay supervisores registrados.</span>';
                    return;
                }
                
                listContainer.innerHTML = `
                    <table class="table">
                        <thead><tr><th>Usuario</th><th>Contacto</th><th>Taquillas Asignadas</th><th>Acciones</th></tr></thead>
                        <tbody>
                            ${adminsList.map(a => `
                                <tr>
                                    <td><b>${a.username}</b></td>
                                    <td>${a.full_name}<br><small style="color:#94a3b8">${a.email || 'Sin email'}<br>${a.phone_number || 'Sin tlf.'}</small></td>
                                    <td>
                                        <div style="max-height: 60px; overflow-y: auto; font-size: 0.8rem; color:#cbd5e1;">
                                            ${a.assigned_cashiers.length > 0 ? a.assigned_cashiers.map(c => `• ${c.cashier_username}`).join('<br>') : '<span style="color:#ef4444">Ninguna</span>'}
                                        </div>
                                    </td>
                                    <td>
                                        <div style="display:flex; gap:5px;">
                                            <button class="btn-warning btn-sm" onclick="editDashboardAdmin(${a.id})" title="Editar Taquillas"><i class="fas fa-edit"></i></button>
                                            <button class="btn-danger btn-sm" onclick="deleteDashboardAdmin(${a.id})" title="Eliminar"><i class="fas fa-trash"></i></button>
                                        </div>
                                    </td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                `;
            } catch (e) { if (checkAuthError(e)) return; listContainer.innerHTML = '<span style="color:#ef4444">Error cargando supervisores.</span>'; }
        };

        await loadAdmins();

        container.querySelector('#btn-copy-apk-msg').addEventListener('click', () => {
            const link = container.querySelector('#apk-drive-link').value.trim();
            if (!link) return Notification(notifContainer, 'Debes ingresar un enlace válido de Google Drive.', 'error');
            
            localStorage.setItem('admin_apk_drive_link', link);
            
            const msg = `📲 *App de Monitoreo Hípico*\n\n1️⃣ Descarga e instala el APK desde este enlace seguro de Google Drive:\n${link}\n\n2️⃣ Abre la App e inicia sesión con el Usuario y Contraseña que te han asignado.\n\n📊 ¡Monitorea tus taquillas en tiempo real!`;
            
            navigator.clipboard.writeText(msg).then(() => {
                Notification(notifContainer, 'Mensaje copiado. Pégalo en WhatsApp o Telegram.', 'success');
            }).catch(() => {
                Notification(notifContainer, 'Error al copiar al portapapeles.', 'error');
            });
        });

        container.querySelector('#register-dashadmin-form').addEventListener('submit', async (e) => {
            e.preventDefault();
            const btn = e.target.querySelector('button[type="submit"]');
            btn.disabled = true; btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Registrando...';
            const selectedCashiers = Array.from(container.querySelectorAll('.da-cashier-cb:checked')).map(cb => parseInt(cb.value));
            try {
                await api.post('/users/dashboard-admins', {
                    username: container.querySelector('#da-username').value.trim(),
                    password: container.querySelector('#da-password').value,
                    full_name: container.querySelector('#da-fullname').value.trim(),
                    phone_number: container.querySelector('#da-phone').value.trim(),
                    email: container.querySelector('#da-email').value.trim(),
                    assigned_cashiers: selectedCashiers
                });
                Notification(notifContainer, 'Supervisor registrado exitosamente.', 'success');
                e.target.reset();
                await loadAdmins();
            } catch (err) { if (checkAuthError(err)) return; Notification(notifContainer, err.message || 'Error en el registro', 'error'); } 
            finally { btn.disabled = false; btn.innerHTML = '<i class="fas fa-save"></i> Registrar Supervisor'; }
        });

        window.deleteDashboardAdmin = async (id) => {
            if (!confirm('¿Eliminar este supervisor? Sus taquillas no serán borradas.')) return;
            try {
                await api.delete(`/users/dashboard-admins/${id}`);
                Notification(notifContainer, 'Supervisor eliminado.', 'success');
                await loadAdmins();
            } catch (err) { if (checkAuthError(err)) return; Notification(notifContainer, err.message || 'Error eliminando', 'error'); }
        };

        // ⭐ NUEVA FUNCIÓN: Modal de Edición de Taquillas Asignadas
        window.editDashboardAdmin = (id) => {
            const admin = adminsList.find(a => a.id === id);
            if (!admin) return;

            // Extraemos los IDs de las taquillas que ya tiene asignadas para pre-marcarlas
            const assignedIds = admin.assigned_cashiers.map(c => parseInt(c.cashier_id));

            const modal = document.createElement('div');
            modal.className = 'modal-overlay visible';
            modal.innerHTML = `
                <div class="modal-content" style="max-width: 450px;">
                    <div style="border-bottom: 1px solid #334155; margin-bottom: 15px; padding-bottom: 10px;">
                        <h3 style="color: #D4AF37; margin: 0;"><i class="fas fa-user-edit"></i> Editar Taquillas Asignadas</h3>
                        <p style="color: #94a3b8; font-size: 0.9rem; margin-top: 5px;">Supervisor: <b style="color: white;">${admin.username}</b></p>
                    </div>
                    
                    <div class="form-group">
                        <label style="color:#cbd5e1; font-weight:bold; font-size:0.85rem;">Selecciona las taquillas:</label>
                        <div style="background: #0f172a; border: 1px solid #475569; border-radius: 6px; padding: 10px; max-height: 250px; overflow-y: auto;">
                            ${cashiersList.length === 0 ? '<span style="color:#ef4444">No hay taquillas creadas.</span>' : 
                                cashiersList.map(c => `
                                    <label style="display:flex; align-items:center; gap:8px; margin-bottom:10px; cursor:pointer; color:#f8fafc; font-size:0.9rem;">
                                        <input type="checkbox" class="edit-da-cashier-cb" value="${c.id}" ${assignedIds.includes(c.id) ? 'checked' : ''} style="width:18px; height:18px; accent-color: #D4AF37;">
                                        ${c.username} - ${c.full_name}
                                    </label>
                                `).join('')
                            }
                        </div>
                    </div>
                    
                    <div style="display:flex; gap:10px; margin-top:20px;">
                        <button class="btn-secondary cancel-edit" style="flex:1; padding: 10px;">Cancelar</button>
                        <button class="btn-success save-edit" style="flex:1; padding: 10px;"><i class="fas fa-save"></i> Guardar Cambios</button>
                    </div>
                </div>
            `;
            
            document.body.appendChild(modal);

            modal.querySelector('.cancel-edit').onclick = () => modal.remove();

            modal.querySelector('.save-edit').onclick = async (e) => {
                const btn = e.currentTarget;
                btn.disabled = true;
                btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Guardando...';

                const selectedCashiers = Array.from(modal.querySelectorAll('.edit-da-cashier-cb:checked')).map(cb => parseInt(cb.value));

                try {
                    // Actualiza usando el método PUT al endpoint del dashboard admin
                    await api.put(`/users/dashboard-admins/${id}`, {
                        assigned_cashiers: selectedCashiers
                    });
                    Notification(notifContainer, 'Taquillas asignadas correctamente.', 'success');
                    modal.remove();
                    await loadAdmins(); // Refresca la tabla en segundo plano
                } catch (err) {
                    if (checkAuthError(err)) { modal.remove(); return; }
                    Notification(notifContainer, err.message || 'Error al actualizar taquillas', 'error');
                    btn.disabled = false;
                    btn.innerHTML = '<i class="fas fa-save"></i> Guardar Cambios';
                }
            };
        };
    }

    async function renderRemateUsersManagement(container, notifContainer) {
        container.innerHTML = `<div id="remate-users-loader" class="loader-container"><i class="fas fa-spinner fa-spin"></i> Cargando usuarios y operadores...</div>`;

        let allRemateUsers = [];
        let allOperators = [];

        try {
            [allRemateUsers, allOperators] = await Promise.all([
                api.get('/remate/users'),
                api.get('/users?role=payout_agent') // <--- Cambio aquí
            ]);
        } catch (e)  {
            if (checkAuthError(e)) return;
            container.innerHTML = `<div class="text-danger text-center">Error cargando los datos. ${e.message}</div>`;
            return;
        }

        const renderTable = () => {
            container.innerHTML = `
                <p class="content-desc" style="color: #94a3b8; font-size: 0.9rem; margin-bottom: 20px;">
                    Asigna operadores y establece límites de apuesta para los usuarios de la aplicación de Remates VIP.
                </p>
                <div class="table-responsive">
                    <table class="table">
                        <thead>
                            <tr>
                                <th>Alias / Usuario</th>
                                <th>Contacto</th>
                                <th>Operador Asignado</th>
                                <th style="text-align:right;">Saldo ($)</th>
                                <th style="text-align:center;">Acción</th>
                            </tr>
                        </thead>
                        <tbody id="remate-users-tbody">
                            ${allRemateUsers.map(user => `
                                <tr>
                                    <td><b>${user.alias || user.username}</b></td>
                                    <td class="text-muted" style="font-size:0.85rem;">${user.phone_number || 'Sin Teléfono'}<br>${user.email || 'Sin Email'}</td>
                                    <td>
                                        ${user.ally_name 
                                            ? `<span style="background:#10b981; color:white; padding: 3px 8px; border-radius:4px; font-size:0.8rem; font-weight:bold;">${user.ally_name}</span>` 
                                            : '<span style="color:#94a3b8;">Directo (Sin Operador)</span>'
                                        }
                                    </td>
                                    <td style="text-align:right; font-family:monospace; font-weight:bold; color:var(--accent-gold); font-size:1.1rem;">$${parseFloat(user.balance_usd || 0).toFixed(2)}</td>
                                    <td style="text-align:center;">
                                        <button class="btn-primary btn-manage-remate-user" data-user-id="${user.id}" style="padding: 8px 12px; font-size:0.9rem;">
                                            <i class="fas fa-user-edit"></i> Gestionar
                                        </button>
                                    </td>
                                </tr>
                            `).join('')}
                        </tbody>
                    </table>
                </div>
            `;

            container.querySelectorAll('.btn-manage-remate-user').forEach(btn => {
                btn.addEventListener('click', (e) => {
                    const userId = e.currentTarget.dataset.userId;
                    const user = allRemateUsers.find(u => String(u.id) === userId);
                    openRemateUserModal(user, allOperators, async () => {
                        // Refresh logic
                        try {
                            allRemateUsers = await api.get('/remate/users');
                            renderTable();
                        } catch (err) {
                            Notification(notifContainer, 'Error refrescando la lista.', 'error');
                        }
                    });
                });
            });
        };

        renderTable();
    }

    function openRemateUserModal(user, operators, onSaveCallback) {
    const modalId = 'remate-user-modal';
    let existingModal = document.getElementById(modalId);
    if (existingModal) existingModal.remove();

    const operatorOptions = operators.map(op => 
        `<option value="${op.username}" ${user.ally_name === op.username ? 'selected' : ''}>${op.username} (${op.full_name})</option>`
    ).join('');

    const modal = document.createElement('div');
    modal.id = modalId;
    modal.className = 'modal-overlay visible';
    modal.innerHTML = `
        <div class="modal-content" style="max-width: 550px;">
            <button class="close-btn" onclick="this.closest('.modal-overlay').remove()">&times;</button>
            <h3>Gestionar Usuario VIP: ${user.alias}</h3>

            <div class="form-group">
                <label for="ally-selector">Asignar Operador / Taquilla</label>
                <select id="ally-selector" class="remate-select">
                    <option value="">Directo (Sin Operador)</option>
                    ${operatorOptions}
                </select>
            </div>

            <hr/>

            <h4 style="color: var(--danger);"><i class="fas fa-shield-alt"></i> Límites de Apuesta</h4>
            <div class="form-group">
                <label>Monto Máximo por Apuesta ($)</label>
                <input type="number" id="remate-max-bet" class="remate-input" value="${user.max_bet_limit || ''}" placeholder="Sin límite (Usa el global)">
            </div>
            <div class="form-group">
                <label>Cantidad Máxima de Apuestas por Carrera</label>
                <input type="number" id="remate-max-bets-race" class="remate-input" value="${user.max_bets_per_race || ''}" placeholder="Sin límite (Usa el global)">
            </div>

            <h4 style="color: #10b981; margin-top: 15px;"><i class="fas fa-money-bill-wave"></i> Límites de Pago / Retiros</h4>
            <div class="form-group">
                <label>Límite Máximo de Pago en Dólares ($)</label>
                <input type="number" id="remate-max-payout-usd" class="remate-input" value="${user.max_payout_usd || ''}" placeholder="Sin límite">
            </div>
            <div class="form-group">
                <label>Límite Máximo de Pago en Bolívares (Bs)</label>
                <input type="number" id="remate-max-payout-ves" class="remate-input" value="${user.max_payout_ves || ''}" placeholder="Sin límite">
            </div>

            <div class="modal-actions" style="margin-top: 20px; border-top: 1px solid #334155; padding-top: 15px;">
                <button class="btn-secondary" onclick="this.closest('.modal-overlay').remove()">Cancelar</button>
                <button id="save-remate-user-btn" class="btn-success">Guardar Cambios</button>
            </div>
        </div>
    `;

    document.body.appendChild(modal);

    modal.querySelector('#save-remate-user-btn').addEventListener('click', async (e) => {
        const btn = e.currentTarget;
        btn.disabled = true;
        btn.innerHTML = '<i class="fas fa-spinner fa-spin"></i> Guardando...';

        const selectedAlly = modal.querySelector('#ally-selector').value;
        const maxBet = modal.querySelector('#remate-max-bet').value;
        const maxBetsRace = modal.querySelector('#remate-max-bets-race').value;
        const maxPayoutUsd = modal.querySelector('#remate-max-payout-usd').value;
        const maxPayoutVes = modal.querySelector('#remate-max-payout-ves').value;

        try {
            // Promesa 1: Asignar operador
            const allyPromise = api.post('/remate/users/set-ally', {
                userId: user.id,
                allyName: selectedAlly || null
            });

            // Promesa 2: Actualizar límites apuntando al NUEVO endpoint exclusivo de remates
            const limitsPromise = api.put(`/remate/users/${user.id}/limits`, {
                max_bet_limit: maxBet === '' ? null : parseFloat(maxBet),
                max_bets_per_race: maxBetsRace === '' ? null : parseInt(maxBetsRace),
                max_payout_usd: maxPayoutUsd === '' ? null : parseFloat(maxPayoutUsd),
                max_payout_ves: maxPayoutVes === '' ? null : parseFloat(maxPayoutVes)
            });

            await Promise.all([allyPromise, limitsPromise]);

            Notification(document.querySelector('.notification-container-admin'), 'Usuario actualizado correctamente.', 'success');
            modal.remove();
            if (onSaveCallback) onSaveCallback();

        } catch (err) {
            if (checkAuthError(err)) return;
            Notification(document.querySelector('.notification-container-admin'), err.message || 'Error al guardar.', 'error');
        } finally {
            btn.disabled = false;
            btn.innerHTML = 'Guardar Cambios';
        }
    });
}

    renderMenu();
    // Cargar la primera sección por defecto
    renderSection('remates-management');
    sidebar.querySelector('.admin-sidebar-link[data-section-id="remates-management"]').classList.add('active');

    page.appendChild(Footer());
    return page;
}